<template>
  <div
    class="upsell-page"
    data-testid="mcp-upsell"
  >
    <div class="upsell-mat">
      <span class="upsell-badge">
        <i class="material-symbols-rounded">bolt</i>
        Available on Team and Enterprise plans
      </span>

      <div class="upsell-copy">
        <h2>Connect Hubstaff to your AI tools</h2>
        <p class="upsell-lead">
          Ask Claude, ChatGPT, or Cursor about your team’s time, projects, and activity. Answers come
          straight from live Hubstaff data, with no exports and no spreadsheets.
        </p>
      </div>

      <McpUpsellIllustration />

      <ul class="upsell-benefits">
        <li>
          <i class="material-symbols-rounded">check_circle</i>
          <span>
            <b>Ask and get answers</b>
            Get clear summaries, comparisons, and trends without building reports.
          </span>
        </li>
        <li>
          <i class="material-symbols-rounded">check_circle</i>
          <span>
            <b>Keep exploring naturally</b>
            Use follow-up prompts to dig deeper without starting over.
          </span>
        </li>
        <li class="benefit-security">
          <i class="material-symbols-rounded">shield</i>
          <span>
            <b>Secure and permission-aware</b>
            Read-only access respects existing Hubstaff permissions.
          </span>
        </li>
      </ul>

      <div class="upsell-cta">
        <a
          v-if="canUpgrade"
          :href="upgradeUrl"
          class="zbtn zbtn-primary"
          data-testid="mcp-upsell-upgrade"
        >Upgrade to get started</a>

        <p
          v-else
          class="upsell-ask"
          data-testid="mcp-upsell-ask-owner"
        >Ask an organization owner to upgrade</p>
      </div>
    </div>
  </div>
</template>

<script>
import McpUpsellIllustration from '~/components/hubstaff_mcp/McpUpsellIllustration.vue';

export default {
  name: 'McpUpsell',
  components: { McpUpsellIllustration },
  props: {
    canUpgrade: { type: Boolean, default: false },
    upgradeUrl: { type: String, required: true },
  },
};
</script>

<style scoped>
.upsell-page {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upsell-mat {
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  padding: 24px 0 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  text-align: center;
}

.upsell-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 10px 6px 8px;
  border-radius: 16px;
  background: var(--purple-100);
  color: var(--purple-800);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.upsell-badge .material-symbols-rounded {
  font-size: 18px;
}

.upsell-copy {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.upsell-copy h2 {
  margin: 0;
  color: var(--gray-900);
  font-size: 30px;
  font-weight: 300;
  line-height: 32px;
  letter-spacing: -0.28px;
}

.upsell-lead {
  margin: 0;
  max-width: 560px;
  color: var(--gray-600);
  font-size: 14px;
  line-height: 24px;
}

.upsell-benefits {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
  max-width: 720px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  text-align: left;
}

.upsell-benefits li {
  display: flex;
  gap: 10px;
  font-size: 14px;
  line-height: 20px;
  color: var(--gray-600);
}

.upsell-benefits li > .material-symbols-rounded {
  flex: none;
  font-size: 20px;
  color: var(--green-600);
}

.benefit-security .material-symbols-rounded {
  color: var(--indigo-600);
}

.upsell-benefits b {
  display: block;
  margin-bottom: 2px;
  color: var(--gray-900);
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}

.upsell-cta {
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.upsell-ask {
  margin: 0;
  font-size: 14px;
  color: var(--gray-500);
}

.zbtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  max-height: 40px;
  padding: 10px 20px;
  border: 1px solid transparent;
  border-radius: var(--rounded-md);
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  white-space: nowrap;
  cursor: pointer;
  text-decoration: none;
}

.zbtn-primary {
  background: var(--primary-500);
  color: #fff;
}

.zbtn-primary:hover {
  background: var(--primary-600);
  color: #fff;
}

@media (max-width: 900px) {
  .upsell-benefits {
    grid-template-columns: 1fr;
  }
}
</style>
